<template>
  <div>
    <div class="two-columns">
      <div><h3>1. Choose a sound</h3>
        <div v-for="sound in stage.sounds" :key="sound.id" class="matching-row">
          <button class="secondary" :class="{ chosen: selected === sound.id }" :aria-pressed="selected === sound.id" :disabled="disabled" @click="selectSound(sound.id)">{{ sound.label }}<span v-if="state.matches[sound.id]"> → {{ state.matches[sound.id] }}</span></button>
          <AudioPlayer :stage-id="stage.id" :src="sound.audio" :label="sound.label" :material-id="sound.id" :disabled="disabled" @action="$emit('action', $event)" />
        </div>
      </div>
      <div><h3>2. Choose a word</h3><div class="card-grid"><button v-for="word in stage.words" :key="word.id" :disabled="disabled || !selected" @click="$emit('action', { type: 'match', sound_id: selected, word_id: word.id })">{{ word.label }}</button></div></div>
    </div>
    <p class="muted">Choose another word to change a match. Recordings are not added, so matches are not scored in this preview.</p>
  </div>
</template>
<script>
import AudioPlayer from './AudioPlayer.vue';
export default { components: { AudioPlayer }, props: { stage: Object, state: Object, disabled: Boolean }, emits: ['action'], data: () => ({ selected: null }), methods: { selectSound(id) { this.selected = id; this.$emit('action', { type: 'sound_choose', sound_id: id }); } } };
</script>

